import { configureStore } from "@reduxjs/toolkit";
import verificationSlice, { setupAxiosInterceptors } from "./verification.slice";

export const store = configureStore({
  reducer: {
    verification: verificationSlice,
  },
});

setupAxiosInterceptors(store);
